import React, { useState, useRef, useEffect } from "react";
import {
  Upload,
  message,
  Button,
  Modal,
  Select,
  Form,
  // AutoComplete,
  Input,
} from "antd";
// import btnStyles from "../../../styles/Custom/Button.module.css";
import btnStyles from "../../../../styles/Custom/Button.module.css";
import { getUploadUrlApi } from "../../../../services/common.services";
import { convertToFormData } from "../../../../helpers/utility";
import {
  addCategoryApi,
  uploadPatientImagesApi,
} from "../../../../services/patient.services";
import useQuery from "../../../../hooks/useQuery";
import { CameraOutlined } from "@ant-design/icons";
import axios from "axios";
import Compressor from "compressorjs";
import { PlusOutlined } from "@ant-design/icons";
import { folderUploadApi } from "../../../../services/op.service";
import modalStyles from "../../../PatientsIP/PatientGallery/galleryCompactModal.module.css";
import "./galleryOp.css";
import {
  getDefaultUploadFileName,
  getUploadBatchSizeError,
  getUploadFileNameError,
  GALLERY_UPLOAD_SIZE_ERROR_KEY,
  GALLERY_UPLOAD_NAME_ERROR_KEY,
} from "../../../../helpers/galleryUtils";
import UploadFilePreviewList from "../../../PatientsIP/PatientGallery/UploadFilePreviewList";
const { Option } = Select;
const { Dragger } = Upload;

const PatientGalleryUpload = ({
  refresh,
  isModalVisible,
  setIsModalVisible,
  folder,
  refreshLabelsPage,
  admissionId,
  labels,
}) => {
  const [form] = Form.useForm();
  // One `onChange` fires per file, so overlapping uploads are counted rather
  // than toggling a single flag — otherwise the Save button could stay
  // disabled after the first of several files finished.
  const [pendingUploads, setPendingUploads] = useState(0);
  const [uploadFile, setUploadFile] = useState([]);
  const [selectedFolder, setSelectedFolder] = useState(null);
  const params = useQuery();
  const inputRef = useRef(null);
  const [newLabel, setNewLabel] = useState("");
  const [isMobile, setIsMobile] = useState(() =>
    typeof window !== "undefined"
      ? window.matchMedia("(max-width: 768px)").matches
      : false
  );

  useEffect(() => {
    const mq = window.matchMedia("(max-width: 768px)");
    const onChange = () => setIsMobile(mq.matches);
    onChange();
    mq.addEventListener("change", onChange);
    return () => mq.removeEventListener("change", onChange);
  }, []);

  // Drop the "please upload files" error as soon as a file actually lands,
  // instead of leaving it on screen until the next submit.
  useEffect(() => {
    if (uploadFile.length > 0) {
      form.setFields([{ name: "upload", errors: [] }]);
    }
  }, [uploadFile, form]);

  const handleRemoveFile = (fileToRemove) => {
    if (fileToRemove?.preview_url?.startsWith("blob:")) {
      URL.revokeObjectURL(fileToRemove.preview_url);
    }

    const filteredFiles = uploadFile.filter(
      (file) => file.path !== fileToRemove.path
    );

    setUploadFile(filteredFiles);
    message.success("Removed file successfully");
  };

  const handleFileNameChange = (path, value) => {
    setUploadFile((prev) =>
      prev.map((file) =>
        file.path === path ? { ...file, file_name: value } : file
      )
    );
  };

  const uploadProps = {
    beforeUpload: (file, fileList) => {
      const file_ext = file.name.split(".").slice(-1)[0].toLowerCase();
      const validImageTypes = ["png", "jpg", "jpeg", "svg"];
      const validVideoTypes = ["mp4", "mov"];
      const validPdfTypes = ["pdf"];

      const fileType =
        validImageTypes.includes(file_ext) ||
        validVideoTypes.includes(file_ext) ||
        validPdfTypes.includes(file_ext);

      if (!fileType) {
        message.error(`${file.name} is not a valid file type`);
        return Upload.LIST_IGNORE;
      }

      const nameError = getUploadFileNameError(file.name);
      if (nameError) {
        message.error({
          content: nameError,
          key: GALLERY_UPLOAD_NAME_ERROR_KEY,
        });
        return Upload.LIST_IGNORE;
      }

      const sizeError = getUploadBatchSizeError(fileList);
      if (sizeError) {
        message.error({
          content: sizeError,
          key: GALLERY_UPLOAD_SIZE_ERROR_KEY,
        });
        return Upload.LIST_IGNORE;
      }

      return true;
    },

    async onChange(info) {
      if (info.file.status === "done") {
        setPendingUploads((count) => count + 1);
        try {
          const res = await getUploadUrlApi(
            `path_key=${info.file.name}&admission_type=OP&admission_id=${admissionId}`
          );

          const formData = convertToFormData(res, info);

          await axios({
            method: "POST",
            url: res?.data?.url,
            data: formData,
            headers: {
              "Content-Type": "multipart/form-data",
            },
          });

          setUploadFile((prevState) => [
            ...prevState,
            {
              path: res?.data?.fields?.key,
              type: info.file.type,
              file_name: getDefaultUploadFileName(info.file),
              preview_url: URL.createObjectURL(
                info.file.originFileObj || info.file
              ),
            },
          ]);
        } catch (err) {
          message.error(
            err?.response?.data?.message || `Failed to upload ${info.file.name}`
          );
        } finally {
          setPendingUploads((count) => Math.max(0, count - 1));
        }
      }
    },
  };

  const dummyRequest = ({ file, onSuccess }) => {
    setTimeout(() => {
      onSuccess("ok");
    }, 0);
  };

  const onFinish = async (val) => {
    const finalFolder = folder || val?.selected_folder || null;

    if (uploadFile.length === 0) {
      message.error("Please upload at least one file");
      return;
    }

    const payload = {
      folder: finalFolder,
      paths: uploadFile.map((file) => ({
        path: file.path,
        type: file.type,
        file_name: file.file_name?.trim() || file.path.split("/").pop(),
      })),
      admission: params?.aid,
    };

    if (val?.sub_folder?.trim()) {
      payload.sub_folder = val.sub_folder.trim();
    }

    folderUploadApi(payload)
      .then(() => {
        message.success("File uploaded successfully");
        refresh();
        setIsModalVisible(false);
      })
      .catch((err) => {
        message.error(err?.response?.data?.message || "Failed to upload files");
      });

    // uploadPatientImagesApi(formData)
    //   .then((response) => {
    //     message.success(response.data.message);
    //     refresh();
    //     setIsModalVisible(false);
    //   })
    //   .catch((error) => {
    //     message.error(error.response.data.message);
    //   });
  };

  // const handleLabelSelect = (value, option) => {
  //   setSelectedFolder(option.value);
  // };

  // const onLabelAdd = (values) => {
  //   const payload = {
  //     name: newLabel,
  //   };

  //   addCategoryApi(payload)
  //     ?.then((res) => {
  //       message.success(res?.data?.message);
  //       refreshLabelsPage();
  //       setNewLabel(null);
  //     })
  //     .catch((err) => message.error(err?.response?.data?.message));
  // };
  return (
    <>
      <Modal
        width={isMobile ? "min(450px, calc(100vw - 24px))" : 450}
        {...(isMobile ? { centered: false } : {})}
        wrapClassName={
          isMobile
            ? `${modalStyles.compactModalWrap} ${modalStyles.galleryUploadModalWrap}`
            : undefined
        }
        styles={{
          content: isMobile
            ? {
                display: "flex",
                flexDirection: "column",
                maxHeight: "calc(100dvh - 32px)",
                overflow: "hidden",
              }
            : undefined,
          body: isMobile
            ? {
                flex: "1 1 auto",
                minHeight: 0,
                maxWidth: "100%",
                overflowX: "hidden",
                overflowY: "auto",
                boxSizing: "border-box",
              }
            : undefined,
          footer: isMobile
            ? {
                flexShrink: 0,
                marginTop: 0,
                background: "#fff",
                borderTop: "1px solid #f0f0f0",
              }
            : undefined,
        }}
        title={`Upload ${folder ? "to " + folder : ""}`}
        onCancel={() => setIsModalVisible(false)}
        open={isModalVisible}
        footer={
          <div
            className="flex-end upload-modal-footer"
            style={{ gap: isMobile ? 12 : 24, marginTop: isMobile ? 0 : 20 }}
          >
            <Button
              type="primary"
              ghost
              style={{ fontWeight: "500" }}
              className={btnStyles.mdBtn}
              onClick={() => setIsModalVisible(false)}
            >
              Cancel
            </Button>
            <Button
              disabled={pendingUploads > 0}
              loading={pendingUploads > 0}
              htmlType="submit"
              type="primary"
              style={{ fontWeight: "500" }}
              className={btnStyles.mdBtn}
              onClick={() => form.submit()}
            >
              Save
            </Button>
          </div>
        }
      >
        <Form
          layout="vertical"
          form={form}
          onFinish={onFinish}
          className={isMobile ? modalStyles.compactForm : undefined}
        >
          {!folder && (
            <Form.Item
              label="Select Label"
              name="selected_folder"
              rules={[{ required: true, message: "Please select a label" }]}
            >
              <Select placeholder="Select label">
                {labels?.map((label) => (
                  <Select.Option key={label} value={label}>
                    {label}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
          )}

          <Form.Item label="Sub Folder" name="sub_folder">
            <Input />
            {/* <Select
              showSearch
              optionFilterProp="children"
              placeholder="Search Labels..."
              onSelect={handleLabelSelect}
              dropdownRender={(menu) => (
                <>
                  {menu}
                  <Divider style={{ margin: "8px 0" }} />
                  <Space style={{ padding: "0 8px 4px" }}>
                    <Input
                      placeholder="Add new label"
                      ref={inputRef}
                      value={newLabel}
                      onChange={(e) => setNewLabel(e.target.value)}
                      onKeyDown={(e) => e.stopPropagation()}
                    />
                    <Button
                      type="text"
                      icon={<PlusOutlined />}
                      onClick={onLabelAdd}
                    >
                      Add
                    </Button>
                  </Space>
                </>
              )}
            >
              {labels?.map((label) => (
                <Option key={label?.id} value={label?.name}>
                  {label?.name}
                </Option>
              ))}
            </Select> */}
          </Form.Item>
          <Form.Item
            label="Upload Gallery"
            name="upload"
            rules={[
              {
                validator: () =>
                  uploadFile.length > 0
                    ? Promise.resolve()
                    : Promise.reject(new Error("Please upload files")),
              },
            ]}
          >
            <Dragger
              className={isMobile ? modalStyles.compactDragger : undefined}
              style={{ width: "100%", maxWidth: isMobile ? "100%" : 400 }}
              accept=".png,.jpg,.jpeg,.svg,.mp4,.mov,.avi,.pdf"
              {...uploadProps}
              multiple
              customRequest={dummyRequest}
              showUploadList={false}
            >
              <p className="ant-upload-drag-icon">
                <CameraOutlined />
              </p>
              <p className="ant-upload-text">
                <span style={{ color: "#406AFF" }}>Click to Capture </span> or
                upload
              </p>
              {/* <p className="ant-upload-hint">
                PDF, SVG, JPEG, JPG, PNG, MP4, MOV, AVI
              </p> */}
            </Dragger>
            {isMobile ? (
              <div className={modalStyles.uploadFileListScroll}>
                <UploadFilePreviewList
                  uploadFile={uploadFile}
                  onRemove={handleRemoveFile}
                  onFileNameChange={handleFileNameChange}
                  isMobile={isMobile}
                />
              </div>
            ) : (
              <UploadFilePreviewList
                uploadFile={uploadFile}
                onRemove={handleRemoveFile}
                onFileNameChange={handleFileNameChange}
                isMobile={isMobile}
              />
            )}
          </Form.Item>
        </Form>
      </Modal>
    </>
  );
};

export default PatientGalleryUpload;
